const DATA_IMPORT = 'dofe-bo/DATA_IMPORT'
const DATA_IMPORT_SUCCESS = 'dofe-bo/DATA_IMPORT_SUCCESS'
const DATA_IMPORT_FAIL = 'dofe-bo/DATA_IMPORT_FAIL'

const DATA_IMPORT_INVITED_PARTICIPANTS = 'dofe-bo/DATA_IMPORT_INVITED_PARTICIPANTS'
const DATA_IMPORT_INVITED_PARTICIPANTS_SUCCESS = 'dofe-bo/DATA_IMPORT_INVITED_PARTICIPANTS_SUCCESS'
const DATA_IMPORT_INVITED_PARTICIPANTS_FAIL = 'dofe-bo/DATA_IMPORT_INVITED_PARTICIPANTS_FAIL'

const initialState = {
  data: [],
  offlineImportLoading: false,
  invitationsImportLoading: false
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case DATA_IMPORT:
      return {
        ...state,
        offlineImportLoading: true
      }
    case DATA_IMPORT_SUCCESS:
      return {
        ...state,
        offlineImportLoading: false,
        data: action.result
      }
    case DATA_IMPORT_FAIL:
      return {
        ...state,
        offlineImportLoading: false
      }
    case DATA_IMPORT_INVITED_PARTICIPANTS:
      return {
        ...state,
        invitationsImportLoading: true
      }
    case DATA_IMPORT_INVITED_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        invitationsImportLoading: false,
        data: action.result
      }
    case DATA_IMPORT_INVITED_PARTICIPANTS_FAIL:
      return {
        ...state,
        invitationsImportLoading: false
      }
    default:
      return state
  }
}

export const onDataImport = data => ({
  types: [DATA_IMPORT, DATA_IMPORT_SUCCESS, DATA_IMPORT_FAIL],
  promise: client => client.post('api/manual-data-import', { data })
})

export const onInvitedParticipantsDataImport = data => ({
  types: [DATA_IMPORT_INVITED_PARTICIPANTS, DATA_IMPORT_INVITED_PARTICIPANTS_SUCCESS, DATA_IMPORT_INVITED_PARTICIPANTS_FAIL],
  promise: client => client.post('api/manual-data-import/invited-participants', { data })
})
